import { buildEventClusterParams } from './buildOpinionTimelineParams';
import {
  buildInitialChartEventSetting,
  hasBubbleEventContent,
} from './buildInitialChartEventSetting';
import {
  buildEventClusterCacheKey,
  getCachedEventClusterData,
} from './eventClusterSessionCache';
import { loadOpinionChartEventSetting } from './opinionChartEventSettingStorage';
import type {
  IOpinionChartEventData,
  IOpinionChartEventSetting,
  IUseOpinionChartEventsParams,
} from '../types';

const EMPTY_EVENT_DATA: IOpinionChartEventData = {
  eventList: {},
  chartRenderEventList: {},
  format: 'YYYY-MM-DD',
  isEmpty: true,
};

/** 从 session 缓存恢复 eventData 与 bubbleEvent，避免返回页面时气泡闪烁 */
export function resolveInitialOpinionChartEventState(
  params: IUseOpinionChartEventsParams,
): {
  eventData: IOpinionChartEventData;
  chartEventSetting: IOpinionChartEventSetting;
} {
  const {
    gameIds,
    startTime,
    endTime,
    dateType,
    settingStorageKey,
    enabled = true,
    needEventData = true,
  } = params;

  const persistedSetting = loadOpinionChartEventSetting(settingStorageKey);
  const baseSetting: IOpinionChartEventSetting = {
    bubbleEvent: {},
    showEventAxis: persistedSetting?.showEventAxis ?? true,
    showEventBubbles: persistedSetting?.showEventBubbles ?? true,
  };

  if (
    !enabled ||
    !needEventData ||
    !gameIds?.length ||
    !startTime ||
    !endTime
  ) {
    return {
      eventData: EMPTY_EVENT_DATA,
      chartEventSetting: baseSetting,
    };
  }

  const requestParams = buildEventClusterParams({
    gameIds,
    startTime,
    endTime,
    dateType,
  });
  const cacheKey = buildEventClusterCacheKey({
    ...requestParams,
    date_type: dateType,
  });
  const cachedEventData = getCachedEventClusterData(cacheKey);

  if (!cachedEventData || cachedEventData.isEmpty) {
    return {
      eventData: EMPTY_EVENT_DATA,
      chartEventSetting: baseSetting,
    };
  }

  return {
    eventData: cachedEventData,
    chartEventSetting: buildInitialChartEventSetting({
      eventData: cachedEventData,
      currentSetting: baseSetting,
      persistedSetting,
      dateType,
    }),
  };
}

export { EMPTY_EVENT_DATA, hasBubbleEventContent };
